"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionOverviewAccumulator = void 0;
const defaultSeverityCount = () => ({
    totalCurrent: 0,
    totalLast: 0,
    numNew: 0,
    numFixed: 0
});
/**
 * `calculateOverview` for a session seen one page state at a time. Each rule counts under its
 * first page state's impact, as the merged rule does; a fixed node is a previous unique no
 * current unique matches, which also covers rules missing from the current session because
 * fingerprints embed the rule id.
 */
class SessionOverviewAccumulator {
    #previous;
    #currentKeys;
    #ruleImpact = new Map();
    #severity = {
        minor: defaultSeverityCount(),
        moderate: defaultSeverityCount(),
        serious: defaultSeverityCount(),
        critical: defaultSeverityCount()
    };
    #unique = 0;
    #duplicates = 0;
    #new = 0;
    constructor({ previous, currentKeys }) {
        this.#previous = previous;
        this.#currentKeys = currentKeys;
    }
    get uniqueNodes() {
        return this.#unique;
    }
    get duplicateNodes() {
        return this.#duplicates;
    }
    add(pageState) {
        for (const ruleResult of pageState.result) {
            if (!this.#ruleImpact.has(ruleResult.id)) {
                this.#ruleImpact.set(ruleResult.id, ruleResult.impact);
            }
            const severity = this.#severity[this.#ruleImpact.get(ruleResult.id)];
            this.#unique += ruleResult.uniques.length;
            for (const count of Object.values(ruleResult.duplicates)) {
                this.#duplicates += count;
            }
            for (const node of ruleResult.uniques) {
                severity.totalCurrent++;
                const existing = this.#previous !== null &&
                    node.fingerprints !== undefined &&
                    node.fingerprints.some(f => this.#previous.fingerprints.has(f));
                if (!existing) {
                    this.#new++;
                    severity.numNew++;
                }
            }
        }
    }
    finish() {
        const numIssueSeverity = structuredClone(this.#severity);
        let fixed = 0;
        for (const [ruleId, rule] of this.#previous?.rules ?? []) {
            const severity = numIssueSeverity[this.#ruleImpact.get(ruleId) ?? rule.impact];
            for (const fingerprints of rule.nodes) {
                severity.totalLast++;
                if (!fingerprints || !this.#currentKeys.hasAny(fingerprints)) {
                    fixed++;
                    severity.numFixed++;
                }
            }
        }
        return {
            currTotalIssues: this.#unique + this.#duplicates,
            currDuplicateIssues: this.#duplicates,
            fixedIssues: fixed,
            newIssues: this.#new,
            currUniqueIssues: this.#unique,
            numIssueSeverity
        };
    }
}
exports.SessionOverviewAccumulator = SessionOverviewAccumulator;
//# sourceMappingURL=sessionOverviewAccumulator.js.map